import * as React from 'react';

var _path, _path2, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgWalletConnect = function SvgWalletConnect(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 121"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_radial_1428_416)",
        fillRule: "evenodd",
        d: "M60 .031c33.14 0 60 26.86 60 60s-26.86 60-60 60-60-26.86-60-60 26.86-60 60-60",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M38.132 46.367c12.07-11.79 31.664-11.79 43.734 0l1.453 1.43c.61.585.61 1.546 0 2.132l-4.968 4.852a.78.78 0 0 1-1.102 0l-1.992-1.946c-8.438-8.226-22.078-8.226-30.516 0l-2.133 2.086a.78.78 0 0 1-1.101 0l-4.969-4.851a1.473 1.473 0 0 1 0-2.133zm54.023 10.03 4.43 4.313c.61.586.61 1.547 0 2.133L76.64 82.32c-.61.586-1.594.586-2.18 0L60.304 68.492a.397.397 0 0 0-.54 0L45.609 82.32c-.609.586-1.593.586-2.18 0L23.414 62.843a1.473 1.473 0 0 1 0-2.133l4.43-4.312c.61-.586 1.593-.586 2.18 0l14.156 13.828c.14.14.398.14.539 0l14.156-13.828c.61-.586 1.594-.586 2.18 0L75.21 70.226c.14.14.398.14.539 0l14.156-13.828c.656-.586 1.64-.586 2.25 0"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint0_radial_1428_416",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(120 0 0 120 0 60.033)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#5D9DF6"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#006FFF"
    })))));
};

export { SvgWalletConnect as ReactComponent };
//# sourceMappingURL=WalletConnect.svg.es.js.map
